import { ApolloLink } from '@apollo/client';
import { getLang } from '@lingoda/env';
import { config } from '@lingoda/config';

export const getHeadersConfigLink = () =>
    new ApolloLink((operation, forward) => {
        operation.setContext({
            headers: {
                Accept: 'application/json',
                'X-Locale': getLang(),
                'X-Release-Id': config.releaseId,
            },
        });

        return forward(operation);
    });
